import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { FoldersListStateService } from '@modules/files/services/folders-list-state.service';
import { FoldersService } from '@modules/files/services/folders.service';
import { Folder } from '@modules/files/types/folder';
import { FoldersFilters } from '@modules/files/types/folders-filters';
import { FoldersListState } from '@modules/files/types/folders-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-folders-section',
  templateUrl: './folders-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...FoldersListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeFoldersSectionComponent
  extends KnowledgeStitchSectionComponent<Folder, FoldersFilters>
  implements OnInit
{
  protected readonly listStateService = inject(FoldersListStateService, { self: true });
  protected readonly stitchService = inject(FoldersService);

  public override ngOnInit(): void {
    this.state = new FoldersFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: FoldersListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new FoldersFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
